"use client";

import { useState } from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
// ✅ Import Tipe Data dari Modal
import ImportModal, { type ImportResponse } from "./ImportModal";

interface ImportButtonProps {
    // ✅ Type Safe: Callback menerima ImportResponse
    onImported?: (result: ImportResponse) => void;
}

export default function ImportButton({ onImported }: ImportButtonProps) {
    const [open, setOpen] = useState(false);

    // ✅ Handler Type Safe
    const handleImported = (data: ImportResponse): void => {
        setOpen(false); // Tutup modal saat sukses

        // Teruskan data ke parent
        if (onImported) {
            onImported(data);
        }
    };

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white shadow-sm transition-all"
            >
                <Upload className="w-4 h-4" />
                Import Peserta
            </Button>

            <ImportModal
                isOpen={open}
                onClose={() => setOpen(false)}
                // ✅ Type Matching: Meneruskan fungsi handleImported yang tipenya sudah cocok
                onImported={handleImported}
            />
        </>
    );
}